import { Injectable, signal } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {

  private routerInfo: BehaviorSubject<boolean>;
  private readonly _display = signal<boolean>(true);
  
  readonly display = this._display.asReadonly()

  constructor() {
    this.routerInfo = new BehaviorSubject<boolean>(false);
  }

  getValue(): Observable<boolean> {
    return this.routerInfo.asObservable();
  }
  setValue(newValue): void {
    this.routerInfo.next(newValue);
  }

}